"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatRuralMilitaryAddressForComponent = exports.formatRuralMilitaryAddress = exports.formatStandardAddress = void 0;
const COMMA_SEPARATOR = ', ';
const SPACE_SEPARATOR = ' ';
const formatStandardAddress = ({ additionalInfo, number, postalCode, street, state, city }) => {
    return [
        [[[number, street].filter(Boolean).join(SPACE_SEPARATOR).trim(), []].filter(Boolean).join(COMMA_SEPARATOR).trim()]
            .filter(Boolean)
            .join(COMMA_SEPARATOR)
            .trim(),
        [additionalInfo, []].filter(Boolean).join(COMMA_SEPARATOR).trim(),
        [city, [state, postalCode].filter(Boolean).join(SPACE_SEPARATOR).trim()].filter(Boolean).join(COMMA_SEPARATOR).trim(),
    ].filter(Boolean);
};
exports.formatStandardAddress = formatStandardAddress;
const formatRuralMilitaryAddress = ({ additionalItems1, city, state, postalCode, }) => {
    return [
        [additionalItems1].filter(Boolean).join(SPACE_SEPARATOR).trim(),
        [city, [state, postalCode].filter(Boolean).join(SPACE_SEPARATOR).trim()].filter(Boolean).join(SPACE_SEPARATOR).trim(),
    ].filter(Boolean);
};
exports.formatRuralMilitaryAddress = formatRuralMilitaryAddress;
const formatRuralMilitaryAddressForComponent = ({ categoryType, unitRoute, box, city, state, postalCode, }) => {
    return [
        [categoryType, unitRoute, 'BOX', box].filter(Boolean).join(SPACE_SEPARATOR).trim(),
        [city, [state, postalCode].filter(Boolean).join(SPACE_SEPARATOR).trim()].filter(Boolean).join(COMMA_SEPARATOR).trim(),
    ].filter(Boolean);
};
exports.formatRuralMilitaryAddressForComponent = formatRuralMilitaryAddressForComponent;
//# sourceMappingURL=utils.js.map